import axios from 'axios'
import { GoogleEnhancedEcommerce, GoogleTagManagerService } from '@/services/AnalyticService'

export default {
  state: {
    searchBarInfo: null,
    searchPageInfo: null,
    searchPageCategories: [],
    searchPageProducts: [],
    searchBarValue: '',
    suggested: [],
    arrowSelectedItem: {},
    searchBarBufferValue: '',
    isSearchPageLoading: false,
    searchHistory: null,
    shouldHistoryShow: true,
    isInputFocused: false,
    firstLoad: true
  },
  getters: {
    allPopupItems (state, getters, rootState) {
      const itemsText = [
        {
          text: state.searchBarBufferValue,
          url: getters.urlLanguagePrefix + '/catalog/search/?text=' + state.searchBarBufferValue
        }
      ]

      if (!state.suggested.length && !state.searchBarInfo && state.searchHistory) {
        state.searchHistory.forEach(el => {
          itemsText.push({ text: el.text, url: getters.urlLanguagePrefix + '/catalog/search/?text=' + el.text })
        })
      }

      state.suggested.forEach(el => {
        itemsText.push({ text: el, url: getters.urlLanguagePrefix + '/catalog/search/?text=' + el, isSuggested: true })
      })

      if (state.searchBarInfo) {
        state.searchBarInfo.categories.forEach(el => {
          itemsText.push({ text: el.name[rootState.translation.language], url: el.url, isCategory: true })
        })

        state.searchBarInfo.products.forEach(el => {
          itemsText.push({ text: el.name[rootState.translation.language], url: el.url, isProduct: true })
        })
      }
      return itemsText
    }
  },
  mutations: {
    SET_SEARCH_BAR_INFO (state, info) {
      if (!info) {
        state.searchBarInfo = null
        return
      }
      state.searchBarInfo = { ...state.searchBarInfo, ...info }
    },
    SET_SEARCH_PAGE_INFO (state, info) {
      state.searchPageInfo = { ...state.searchPageInfo, ...info }
      if (info.products && !Array.isArray(info.products)) {
        state.searchPageProducts = [...state.searchPageProducts, ...info.products.products]
      }
    },
    SET_SEARCH_PAGE_CATEGORIES (state, info) {
      state.searchPageCategories = info
    },
    SET_SEARCH_BAR_VALUE (state, str) {
      state.searchBarValue = str
    },
    SET_SUGGESTIONS (state, info) {
      state.suggested = info
    },
    SET_ARROW_SELECTED_ITEM (state, text) {
      state.arrowSelectedItem = text
    },
    SET_BUFFER_VALUE (state, value) {
      state.searchBarBufferValue = value
    },
    SET_SEARCH_PAGE_LOADING (state, bool) {
      state.isSearchPageLoading = bool
    },
    SET_SEARCH_HISTORY (state, history) {
      state.searchHistory = history
    },
    SET_SHOULD_HISTORY_SHOW (state, bool) {
      state.shouldHistoryShow = bool
    },
    SET_INPUT_FOCUSED (state, bool) {
      state.isInputFocused = bool
    },
    SET_FIRST_LOAD_FLAG (state, bool) {
      state.firstLoad = bool
    }
  },
  actions: {
    FETCH_SEARCH_BAR_INFO ({ commit, rootGetters, dispatch }, str) {
      commit('SET_BUFFER_VALUE', str)

      if (!str) {
        commit('SET_SEARCH_BAR_INFO', null)
        commit('SET_SHOULD_HISTORY_SHOW', true)
        commit('SET_SUGGESTIONS', [])
        return
      }

      axios
        .get(rootGetters.urlLanguagePrefix + '/search/drop-down/?q=' + str)
        .then(response => {
          commit('SET_SEARCH_BAR_INFO', response.data)
          if (response.data?.suggests) {
            commit('SET_SUGGESTIONS', response.data.suggests)
          }

          if (response?.data?.products?.length) {
            response.data.products.forEach((product, index) => {
              GoogleTagManagerService.productViewEvent({
                analyticsData: [
                  {
                    'name': product.name.ru,
                    'id': product.id,
                    'price': product.price_new,
                    'category': product.category_parent_id + '/' + product.category_id,
                    'list': 'Suggest Results',
                    'position': index + 1
                  }
                ]
              })
            })
          } else {
            GoogleEnhancedEcommerce.emptySearchResults(str)
          }
        })
        .finally(() => commit('SET_SHOULD_HISTORY_SHOW', false))
    },
    FETCH_SEARCH_PAGE_INFO ({ commit, rootGetters, state }, params) {
      if (state.searchPageInfo) {
        params.offset = state.searchPageInfo.products.offset
      }
      commit('SET_SEARCH_PAGE_LOADING', true)

      axios
        .get(rootGetters.urlLanguagePrefix + '/search/page/', { params })
        .then(response => {
          commit('SET_SEARCH_PAGE_CATEGORIES', response.data?.categories ?? [])
          commit('SET_SEARCH_PAGE_INFO', response.data)
          commit('SET_SEARCH_PAGE_LOADING', false)
          commit('SET_FIRST_LOAD_FLAG', false)
          if (!response?.data?.products?.products?.length) {
            GoogleEnhancedEcommerce.emptySearchResults(params.q)
          }
        })
    },
    SET_FROM_KEYBOARD ({ commit, getters }, index) {
      commit('SET_SEARCH_BAR_VALUE', getters.allPopupItems[index - 1].text)
      commit('SET_ARROW_SELECTED_ITEM', getters.allPopupItems[index - 1])
    },
    REMOVE_ARROW_SELECTED_ITEM ({ commit }) {
      commit('SET_ARROW_SELECTED_ITEM', {})
    },
    FETCH_SEARCH_HISTORY ({ commit, rootGetters, state }) {
      if (state.searchHistory === false || state.searchHistory === '' || state.searchHistory) return
      commit('SET_SEARCH_HISTORY', false)

      axios
        .get(rootGetters.urlLanguagePrefix + '/search/history/')
        .then(response => commit('SET_SEARCH_HISTORY', response.data))
    },
    SET_SEARCH_BAR_VALUE_ACTION ({ commit }, str) {
      commit('SET_SEARCH_BAR_VALUE', str)
    },
    CLEAR_HISTORY ({ rootGetters, commit }) {
      axios
        .get(rootGetters.urlLanguagePrefix + '/search/clear-history/')
        .then(response => {
          if (response.data.success) {
            commit('SET_SEARCH_HISTORY', null)
          } else commit('SET_ERROR_FROM_SERVER', rootGetters.translations('error_occurred'))
        })
        .catch(() => commit('SET_ERROR_FROM_SERVER', rootGetters.translations('error_occurred')))
    },
    SET_INPUT_FOCUSED_ACTION ({ commit }, bool) {
      commit('SET_INPUT_FOCUSED', bool)
    },
    SEND_SUGGEST_HISTORY ({ rootGetters }, value) {
      return new Promise((resolve, reject) => {
        axios
          .get(rootGetters.urlLanguagePrefix + '/search/set-suggest-history/?text=' + value)
          .then(res => resolve(res.data))
          .catch(err => reject(err))
      })
    }
  }
}
